module.exports = __webpack_public_path__ + "img/logo-dark.362ce7d1.png";